import { NewParagraph, ParagraphEdit } from "@/domains/pusher/schemas";
import {
  ChatConversationUpsertedSyncUpdateValue,
  ChatMessageUpsertedSyncUpdateValue,
} from "@/store/chat/types";
import { SpaceAccountNoteSuggestion } from "@/store/note";
import {
  SessionUpsertedSyncUpdateValue,
  SessionEventUpsertedSyncUpdateValue,
  SessionStatus,
} from "@/store/sessions/types";

export enum PusherServicePrefix {
  BACKEND_API = "BACKEND_API",
  AUTHENTICATED_BACKEND_API = "private-BACKEND_API",
}

export enum PusherDomainPrefix {
  IMAGE_FILE = "IMAGE_FILE",
  SPACE_SCOPED_SYNC_UPDATE = "SPACE_SCOPED_SYNC_UPDATE",
  COLLECTION_SCOPED_SYNC_UPDATE = "COLLECTION_SCOPED_SYNC_UPDATE",
  SPACE_ACCOUNT_SCOPED_SYNC_UPDATE = "SPACE_ACCOUNT_SCOPED_SYNC_UPDATE",
  CHAT_CONVERSATION_SCOPED_SYNC_UPDATE = "CHAT_CONVERSATION_SCOPED_SYNC_UPDATE",
  CHAT_CONVERSATION_LIVE_SYNC_UPDATE = "CHAT_CONVERSATION_LIVE_SYNC_UPDATE",
  SPACE_ACCOUNT_NOTE_LIVE_SYNC_UPDATE = "SPACE_ACCOUNT_NOTE_LIVE_SYNC_UPDATE",
  SESSION_LIVE_SYNC_UPDATE = "SESSION_LIVE_SYNC_UPDATE",
}

export enum PusherEventKind {
  BACKEND_IMAGE_FILE_INDEXING_STATUS_UPDATE = "INDEXING_STATUS_UPDATE",
  SYNC_UPDATE_PUBLISHED = "SYNC_UPDATE_PUBLISHED",
  CHAT_CONVERSATION_MESSAGE_UPSERTED = "CHAT_CONVERSATION_MESSAGE_UPSERTED",
  CHAT_CONVERSATION_UPSERTED = "CHAT_CONVERSATION_UPSERTED",
  SPACE_ACCOUNT_NOTE_SUGGESTION_PUBLISHED = "SPACE_ACCOUNT_NOTE_SUGGESTION_PUBLISHED",
  ASSISTANT_NOTE_EDIT_SUGGESTED = "ASSISTANT_NOTE_EDIT_SUGGESTED",
  SESSION_UPSERTED = "SESSION_UPSERTED",
  SESSION_EVENT_UPSERTED = "SESSION_EVENT_UPSERTED",
  SESSION_STATUS_UPDATED = "SESSION_STATUS_UPDATED",
}

export type PusherEventData<TKind extends PusherEventKind> = {
  [PusherEventKind.BACKEND_IMAGE_FILE_INDEXING_STATUS_UPDATE]: {
    image_file_id: string;
    processing_status: string;
    indexing_status: string;
    suggested_search: string | null;
  };
  [PusherEventKind.SYNC_UPDATE_PUBLISHED]: {
    id: string;
  };
  [PusherEventKind.CHAT_CONVERSATION_MESSAGE_UPSERTED]: {
    sync_operation_id: string;
    value: ChatMessageUpsertedSyncUpdateValue;
  };
  [PusherEventKind.CHAT_CONVERSATION_UPSERTED]: {
    sync_operation_id: string;
    value: ChatConversationUpsertedSyncUpdateValue;
  };
  [PusherEventKind.SPACE_ACCOUNT_NOTE_SUGGESTION_PUBLISHED]: {
    note_id: string;
    space_account_id: string;
    space_account_note_id: string;
    suggestions: SpaceAccountNoteSuggestion[];
  };
  [PusherEventKind.ASSISTANT_NOTE_EDIT_SUGGESTED]: {
    paragraph_edits: ParagraphEdit[];
    new_paragraphs: NewParagraph[];
  };
  [PusherEventKind.SESSION_UPSERTED]: {
    sync_operation_id: string;
    value: SessionUpsertedSyncUpdateValue;
  };
  [PusherEventKind.SESSION_EVENT_UPSERTED]: {
    sync_operation_id: string;
    value: SessionEventUpsertedSyncUpdateValue;
  };
  [PusherEventKind.SESSION_STATUS_UPDATED]: {
    session_id: string;
    status: SessionStatus;
  };
}[TKind];
